import { Injectable } from '@angular/core';
import { PolicyHelperService } from '@client/app/blocks/helpers/policy-helper/policy.helper.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { POLICY_MODES } from '@client/app/modules/policies/constants/policy-modes';
import { MON_ICONS } from '@monsido/ng2/layout/icons/icons.constants';

@Injectable({
    providedIn: 'root',
})
export class PolicyTableService {
    private archivedPolicyTab = 'archived';
    private policyTab: string = '';

    constructor (
        private policyHelperService: PolicyHelperService,
        private sessionService: SessionService,
        private dateTimeService: DateTimeService,
        private translateService: TranslateService,
    ) {}

    areAnyPoliciesRunning (policies: any[]): boolean {
        return policies.some(policy => policy.state === 'running');
    }

    targetHasRun (policy: any): boolean {
        const target = this.policyHelperService.getTargetDomain(policy.targets);
        return Boolean(target && target.latest_run_at);
    }

    policyScanValid (policy: any): boolean {
        if (this.sessionService.domain !== null && policy.state !== 'running' && this.targetHasRun(policy)) {
            const target = this.policyHelperService.getTargetDomain(policy.targets);
            return this.dateTimeService.diff(this.sessionService.domain.last_scan, target.latest_run_at, 'hour') < 24;
        }
        return false;
    }

    getTabs (globalPolicy?: boolean): any[] {
        if (typeof globalPolicy !== 'boolean') {
            globalPolicy = true;
        }

        const policiesIcons = (MON_ICONS.POLICIES as any).MODES;
        const tabs = [
            {
                name: this.translateService.getString('All'),
                value: '',
            },
            {
                name: this.translateService.getString('Unwanted'),
                value: POLICY_MODES.violation,
                faIcon: policiesIcons.violation,
            },
            {
                name: this.translateService.getString('Required'),
                value: POLICY_MODES.required,
                faIcon: policiesIcons.required,
            },
            {
                name: this.translateService.getString('Matches'),
                value: POLICY_MODES.search,
                faIcon: policiesIcons.search,
            },
            {
                name: this.translateService.getString('Archived'),
                value: this.archivedPolicyTab,
                faIcon: policiesIcons.archived,
            },
        ];

        return tabs.filter(tab => {
            if (globalPolicy) {
                return true;
            }
            return [this.archivedPolicyTab].indexOf(tab.value || '') === -1;
        });
    }

    setTab (tab: string): void {
        this.policyTab = tab;
    }

    getTab (): string | null {
        if (this.policyTab === this.archivedPolicyTab || this.policyTab === '') {
            return null;
        }
        return this.policyTab;
    }

    getShowArchivedPolicies (): boolean | null {
        if (this.policyTab === POLICY_MODES.search || this.policyTab === POLICY_MODES.violation || this.policyTab === POLICY_MODES.required) {
            return false;
        } else if (this.policyTab === this.archivedPolicyTab) {
            return true;
        }
        return null;
    }
}
